class Header extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    (this.announcement = document.querySelector(".announcement--root")),
      (this.container = this.querySelector(".header--container")),
      (this.current_width = window.innerWidth),
      (this.fixed_enabled = "true" === this.getAttribute("data-fixed-enabled")),
      (this.fixed_state = !1);
    var e = this.querySelector(".y-menu"),
      t = document.querySelector(".mobile-nav--menu"),
      i = this.querySelector(".header--localization-for-off-canvas > *"),
      s = document.querySelector(".mobile-nav--localization"),
      h = document.querySelector(".mobile-nav--login"),
      r = this.querySelector(".mobile-nav--login--for-off-canvas > *"),
      n = document.querySelector(".mobile-nav--search");
    (this.mobile_nav_search_icon = this.querySelector(
      ".mobile-nav--search--for-off-canvas > *"
    )),
      (this.element_pairs = [
        { parent: t, child: e },
        { parent: h, child: r },
        { parent: n, child: this.mobile_nav_search_icon },
        { parent: s, child: i },
      ]),
      this.load(),
      this.trigger("loaded");
  }
  load() {
    this.element_pairs.forEach((e) => this.moveElement(e.parent, e.child)),
      Shopify.designMode && (this.sectionListeners(), this.inspectListeners()),
      this.fixed_enabled &&
        ((this.header_fill = this.previousElementSibling),
        (this.clone = this.cloneNode(!0)),
        this.initFixed(),
        window.on("theme:XMenu:loaded", () => this.initFixed()));
  }
  moveElement(e, t) {
    e && (e.innerHTML = ""), e && t && e.appendChild(t);
  }
  sectionListeners() {
    this.on("theme:section:load", () => {
      window.trigger("theme:modal:close"),
        theme.off_canvas.reset(),
        this.mobile_nav_search_icon &&
          window.trigger("theme:search:updateLinks");
    });
  }
  inspectListeners() {
    this.fixed_enabled &&
      (document.addEventListener("shopify:inspector:activate", () =>
        this.fixHeader(!1)
      ),
      document.addEventListener("shopify:inspector:deactivate", () => {
        setTimeout(() => this.detectAndFixHeader(), 0);
      }));
  }
  initFixed() {
    (this.heights = {
      fixed: this.getHeaderHeight(!0),
      unfixed: this.getHeaderHeight(!1),
    }),
      this.setHeaderFill(),
      this.setThresholdValues(),
      this.createObserver();
  }
  getHeaderHeight(e) {
    this.clone.setAttribute("data-fixed", e);
    var t = theme.utils.getHiddenDimensions(this.clone, [
      "header-root",
      "x-menu-root",
    ])["height"];
    return t;
  }
  setHeaderFill() {
    (this.header_fill.style.height = this.heights.unfixed - 12 + "px"),
      (this.style.top = this.header_fill.offset().top + "px");
  }
  setThresholdValues() {
    (this.pixel_threshold = this.heights.unfixed - this.heights.fixed),
      (this.observer_threshold = +(
        1 -
        this.pixel_threshold / this.heights.unfixed
      ).toFixed(4)),
      1 < this.observer_threshold && (this.observer_threshold = 1);
  }
  createObserver() {
    this.observer && this.observer.unobserve(this.header_fill),
      (this.observer = new IntersectionObserver(
        () => this.detectAndFixHeader(),
        { threshold: this.observer_threshold }
      )),
      this.observer.observe(this.header_fill);
  }
  detectAndFixHeader() {
    if (!Shopify.inspectMode) {
      let e = this.pixel_threshold;
      this.announcement && (e += this.announcement.offsetHeight),
        window.pageYOffset >= e && !this.fixed_state
          ? this.fixHeader(!0)
          : window.pageYOffset < e && this.fixed_state && this.fixHeader(!1);
    }
  }
  fixHeader(e) {
    (this.fixed_state = e),
      this.setAttribute("data-fixed", e),
      this.trigger("stateChanged", e);
  }
}
customElements.define("header-root", Header);
